import App from "./App";
import { BrowserRouter } from "react-router-dom";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import reportWebVitals from "./reportWebVitals";
import store from "./reducers";

//prevodi

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ["sr", "en", "sl", "al", "bg", "mk", "hr", "hu", "ba"],
    fallbackLng: "sr",
    detection: {
      order: ["localStorage"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: ["translation"], // Dodajte nazive svih vaših fajlova sa prevodima ovde
    defaultNS: "translation", // Naziv osnovnog fajla sa prevodima
    debug: true,
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
